/** Own the stream even when permission or video playback completes after Close. */
export function createCameraSession() {
  let generation = 0;
  let active: MediaStream | null = null;
  const release = (stream: MediaStream) => stream.getTracks().forEach((track) => track.stop());
  function stop() {
    generation++;
    if (active) release(active);
    active = null;
  }
  async function start(acquire: () => Promise<MediaStream>, attach: (stream: MediaStream) => Promise<void>) {
    stop();
    const request = generation;
    try {
      const stream = await acquire();
      if (request !== generation) { release(stream); return false; }
      active = stream;
      await attach(stream);
      return request === generation;
    } catch (error) {
      if (request !== generation) return false;
      stop();
      throw error;
    }
  }
  return { start, stop };
}
